import { Plugin, PluginKey, Transaction } from 'prosemirror-state';
import { generateTaskId } from '../editor-utils';

export const taskPluginKey = new PluginKey('task');
export const TASK_TOGGLE_META = 'taskToggle';

/**
 * Plugin that auto-generates IDs for new task nodes.
 * Click handling is done by TaskNodeView.
 */
export function taskPlugin(): Plugin {
  return new Plugin({
    key: taskPluginKey,
    appendTransaction(transactions: readonly Transaction[], oldState, newState) {
      // Check if any transaction modified the document
      const docChanged = transactions.some((tr) => tr.docChanged);
      if (!docChanged) return null;

      // Find task nodes without IDs and collect their positions
      const positions: number[] = [];
      newState.doc.descendants((node, pos) => {
        if (node.type.name === 'task' && !node.attrs.id) {
          positions.push(pos);
        }
      });

      if (positions.length === 0) return null;

      // Apply in reverse order to avoid position shifting issues
      let tr = newState.tr;
      for (const pos of positions.reverse()) {
        const node = tr.doc.nodeAt(pos);
        if (node) {
          tr = tr.setNodeMarkup(pos, null, {
            ...node.attrs,
            id: generateTaskId(),
          });
        }
      }

      return tr;
    },
  });
}
